var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftRec = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 6.6666L5.83268 9.99999M5.83268 9.99999L9.16602 13.3333M5.83268 9.99999H14.166M9.66602 18.3334H10.3327C13.1329 18.3334 14.5331 18.3334 15.6026 17.7884C16.5434 17.309 17.3083 16.5441 17.7877 15.6033C18.3327 14.5337 18.3327 13.1336 18.3327 10.3333V9.66669C18.3327 6.86643 18.3327 5.46629 17.7877 4.39673C17.3083 3.45592 16.5434 2.69102 15.6026 2.21165C14.5331 1.66669 13.1329 1.66669 10.3327 1.66669H9.66602C6.86575 1.66669 5.46562 1.66669 4.39606 2.21165C3.45525 2.69102 2.69035 3.45592 2.21098 4.39673C1.66602 5.46629 1.66602 6.86643 1.66602 9.66669V10.3333C1.66602 13.1336 1.66602 14.5337 2.21098 15.6033C2.69035 16.5441 3.45525 17.309 4.39606 17.7884C5.46562 18.3334 6.86575 18.3334 9.66602 18.3334Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftRec);
export default ForwardRef;